import {
  AIHighlight,
  CharacterCount,
  Color,
  CustomKeymap,
  HighlightExtension,
  HorizontalRule,
  MarkdownExtension,
  Placeholder,
  StarterKit,
  TextStyle,
  TiptapUnderline,
  AiGeneration,
  AiMark,
  AutoCodexAnnotation
} from "novel";

import { cx } from "class-variance-authority";
import AiGenerationNode from "./generative/ai-generation-node";
// import { common, createLowlight } from "lowlight";

import React from 'react';

//TODO I am using cx here to get tailwind autocomplete working, idk if someone else can write a regex to just capture the class key in objects
const aiHighlight = AIHighlight;
//You can overwrite the placeholder with your own configuration
const placeholder = Placeholder;

const horizontalRule = HorizontalRule.configure({
  HTMLAttributes: {
    class: cx("mt-4 mb-6 border-t border-muted-foreground"),
  },
});

const starterKit = StarterKit.configure({
  bulletList: {
    HTMLAttributes: {
      class: cx("list-disc list-outside"),
    },
  },
  orderedList: {
    HTMLAttributes: {
      class: cx("list-decimal list-outside"),
    },
  },
  listItem: {
    HTMLAttributes: {
    },
  },
  blockquote: {
    HTMLAttributes: {
      class: cx("border-none italic"),
    },
  },
  codeBlock: false,
  code: false,
  horizontalRule: false,
  dropcursor: {
    color: "#e05297",
    width: 2,
  },
  gapcursor: false,
});

const characterCount = CharacterCount.configure();

const aiGeneration = AiGeneration.configure({
  AiGenerationNode: AiGenerationNode,
  dragClass: "ai-generation-drag-handle",
});



export const basicExtensions = [
  starterKit,
  placeholder,
  horizontalRule,
  aiHighlight,
  characterCount,
  TiptapUnderline,
  HighlightExtension,
  TextStyle,
  Color,
  CustomKeymap,
  AutoCodexAnnotation,
  MarkdownExtension,
];

// 增强扩展
export const enhancedExtensions = [
  ...basicExtensions,
  aiGeneration,
  AiMark,
];


// 增加多媒体支持
export const richExtensions = [...enhancedExtensions];